function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#F44336;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 35.5,
  cy: 35.5,
  rx: 35.5,
  ry: 35.1
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M35.8,43.1h-0.7c-2.3,0-4.1-1.8-4.1-4.1V17.9c0-2.3,1.8-4.1,4.1-4.1h0.7c2.3,0,4.1,1.8,4.1,4.1V39 C40,41.2,38.1,43.1,35.8,43.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M35.8,57.2h-0.7c-2.3,0-4.1-1.8-4.1-4.1v-1.6c0-2.3,1.8-4.1,4.1-4.1h0.7c2.3,0,4.1,1.8,4.1,4.1v1.6 C40,55.4,38.1,57.2,35.8,57.2z"
}));

function SvgLogoError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71 71",
    style: {
      enableBackground: "new 0 0 71 71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoError);
export default __webpack_public_path__ + "static/media/Logo_error.d317b060.svg";
export { ForwardRef as ReactComponent };